import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService, UserService } from 'src/app/core';

@Component({
  selector: 'app-edit-user-discount',
  templateUrl: './edit-user-discount.component.html',
  styleUrls: ['./edit-user-discount.component.scss'],
})
export class EditUserDiscountComponent {
  public form: FormGroup;
  readonly dialogRef = inject(MatDialogRef<EditUserDiscountComponent>);
  userId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) dialogData: any,
    private fb: FormBuilder,
    private adminService: AdminService,
    private userService: UserService,
    private snackBar: MatSnackBar
  ) {
    this.form = fb.group({
      // reason: [null, Validators.required],
      // operation: ['received', Validators.required],
      // score: ['0'],

      type: ['cash', Validators.required],
      value: ['0'],
      conditionValue: ['0'],
      expiresAt: [new Date(), Validators.required],
      userIds: [],
      message: [null, Validators.required],
    });
    if (dialogData) this.userId = dialogData.userId;
  }


  // {
  //   type: ‘cash’ | ‘percentage’ | ‘free_delivery’
  //   value: مبلغ تخفیف 
  //   conditionValue: سقف خرید برای درصدی یا حداقل قیمت برای نقدی
  //   expiresAt: تاریخ انقضا
  //   userIds: آرایه ای از آیدی های کاربران
  // message: پیغامی که برای کاربر نوتیف و پیامک می رود
  // }
   
  submitForm() {
    let request = this.form.value;
    request.conditionValue = +request.conditionValue;
    request.value = +request.value;
    
    request = {...request, userIds: [this.userId + '']}

    // delete request.value;
    // delete request.conditionValue;

    this.userService.generateDiscountCode(request).subscribe((res: any) => {
      if (res) {
        this.snackBar.open(`تخصیص کد تخفیف با موفقیت انجام شد.`, '', {
          duration: 1000,
        });
        setTimeout(() => {
          this.dialogRef.close();
        }, 100);
      }
    });
  }
}
